export default function PasswordRuleItem({ passed, children }) {
  return (
    <li className={`flex items-center text-sm mb-1 ${passed ? "text-green-600" : "text-red-600"}`}>
      <span className="mr-2 flex items-center">
        <svg
          className={`w-2 h-2 ${passed ? "fill-green-600" : "fill-red-600"}`}
          viewBox="0 0 5 5"
        >
          <circle cx="2" cy="2" r="2" />
        </svg>
      </span>
      {children}
    </li>
  );
}